module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-12-50.122Z.1bd7f16e.png";